import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions/index';
import './TimeComments.scss';
import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';
import CustomDropdown from 'Flow2/components/Article/Utilities/Dropdown/Dropdown';
import LogsHelper from 'Flow2/components/Article/Helpers/LogsHelper';
import SortHelper from 'Flow2/components/Article/Helpers/SortHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faSave, faTimesCircle, faMinus, faImage } from '@fortawesome/free-solid-svg-icons';
import PageHelper from 'Flow2/components/Article/Helpers/PageHelper';
import TimeHelper from 'Flow2/components/Article/Helpers/DateTimeHelper';
import { injectIntl, FormattedMessage } from 'react-intl';
import { sxmodules, formats, removeSpace } from 'Flow2/components/Article/Helpers/EditorHelper';
import { isPMDB } from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import parse from 'html-react-parser';

import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';

class TimeComments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            mainTextBox: '',
            tabStyle: {}
        }
    }

    getComments = () => {
        let content = [];
        if (this.props.timeComments.clipId == this.props.clip.id && this.props.timeComments.data) {
            const { data } = this.props.timeComments;
            for (let el in data) {
                if (data[el].data) content.push(data[el].data);
            }
        }
        return content
    }

    setInitData = () => {
        this.props.updateArticleObjects({
            articleTimeComments: {
                currentFilter: '', currentSortShowAll: true, currentFilterTrigger: true,
                currentFilterName: this.props.intl.formatMessage({ id: "data.article.commentsfilter" }),
            }
        });
        if (this.props.timeComments) {
            if (this.props.timeComments.clipId == this.props.clip.id && this.props.timeComments.data) {
                let sortedData = SortHelper.sortByValue({ data: this.getComments(), sorted: 'asc', field: 'tcin', isNumber: true, isFloat: true });
                this.setState({ data: sortedData, mainTextBox: '' });
            }
        }
    }

    setInitBtn = () => {
        ArticleTypes.TC_BTN_ITEMS.map(item => this.setState({ [`${item.name}_btnClasses`]: 'custom-button' }));
        this.setState({ [`mainTextBox_Classes`]: 'custom-textbox' })
    }

    setClipDuration = () => {
        const { clipId, currentTarget } = this.props.timeCurrentObj;
        if (clipId && clipId == this.props.clip.id && currentTarget && currentTarget.duration) {
            let clipDuration = currentTarget.duration;
            let hasHours = parseInt(clipDuration / (60 * 60)) > 0 ? true : false;
            this.setState({ clipDuration, hasHours });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.timeComments != this.props.timeComments) {
            this.setInitData();
        }
        if (prevProps.timeCurrentObj != this.props.timeCurrentObj
            && !this.state.clipDuration) {
            this.setClipDuration();
        }
    }

    componentDidMount() {
        this.props.getClipTimeComments(this.props.clip.id, this.props.type);
        this.setInitBtn();
        this.setState({ [`${ArticleTypes.ALL}_btnClasses`]: ArticleTypes.BTN_ACTIVE });
        this.props.changeClipTimeCurrent(this.props.clip.id, ArticleTypes.INIT_DUR);
        if (isPMDB()) this.setActiveTab();
    }

    onChangeHandle = (item, type) => (e) => {
        const { value } = e.target;
        if (item && type && value) {
            let changedEntry = { ...this.state[`commentEntry_${item.id}`], [type]: value };
            this.setState({
                [`commentEntry_${item.id}`]: changedEntry,
                [`timeChanged_${item.id}`]: { ...this.state[`timeChanged_${item.id}`], [type]: value }
            });
        }
    }

    onEditClick = item => (e) => this.setState({ [`commentEdit${item.id}`]: true, [`commentEntry_${item.id}`]: { ...item } });
    
    onTrashClick = (item) => () => {
        // NICK START
        if(this.props.onDelete) {
            this.props.onDelete(item);
        }
        // NICK END
        
        this.props.deleteClipTimeComment(this.props.clip.id, item.id, item);
    }
    onCancelClick = (item) => () => {
        this.setState({ [`commentEdit${item.id}`]: false, [`timeChanged_${item.id}`]: null });
    }

    verifyFields = (item, editedEntry, isValid) => {
        if (this.state[`timeChanged_${item.id}`]) {
            for (let key in this.state[`timeChanged_${item.id}`]) {
                let tc = this.state[`timeChanged_${item.id}`][key];
                let inputEl = document.getElementById(`${key}Input_${item.id}`);
                if (TimeHelper.isTimeCode(tc, this.state.hasHours)) {
                    let convertedTime = TimeHelper.convertToTime(tc, this.state.hasHours);
                    editedEntry = { ...editedEntry, [key]: convertedTime };
                    inputEl.style.border = ArticleTypes.BORDER_LIGHT;
                } else {
                    if (inputEl) {
                        if (!parseInt(tc)) {
                            isValid = false;
                            inputEl.style.border = ArticleTypes.BORDER_RED;
                        } else inputEl.style.border = ArticleTypes.BORDER_LIGHT;
                    }
                }
            }
        }
        return { editedEntry, isValid };
    }

    onSaveClick = item => e => {
        let editedEntry = null;
        let isValid = true;
        let el = document.getElementById(`${item.id}_TextBoxId`);
        if (this.state[`commentEntry_${item.id}`] && el) {
            let comment = this.state[`commentEntry_${item.id}`].comment;
            comment = removeSpace({ text: comment, term: ArticleTypes.TERM });
            if (this.state[`commentEntry_${item.id}`].comment && !comment) {
                this.setState({ [`commentEntry_${item.id}`]: { ...this.state[`commentEntry_${item.id}`], comment: '' } })
                el.style.outline = ArticleTypes.BORDER_RED;
            } else {
                if (comment) editedEntry = { ...item, ...this.state[`commentEntry_${item.id}`], comment };
                else editedEntry = { ...item, ...this.state[`commentEntry_${item.id}`] };
                let res = this.verifyFields(item, editedEntry, isValid);
                editedEntry = res.editedEntry;
                isValid = res.isValid;
            }
        }
        if (editedEntry && isValid) {
            this.setState({ [`commentEdit${item.id}`]: false });
            this.props.updateClipTimeComment(this.props.clip.id, editedEntry);
            if (el) el.style.outline = ArticleTypes.BORDER_NONE;
        }
    }

    searchItems = (el) => {
        if (el) {
            let mainTextBox = el.textContent;
            if (mainTextBox) {
                el.style.outline = ArticleTypes.BORDER_NONE;
                let newData = this.getComments()
                    .filter(item => item.comment && item.comment.toLowerCase().includes(mainTextBox.toLowerCase()));
                this.setState({ data: newData });
            } else {
                this.setInitData();
                el.style.outline = ArticleTypes.BORDER_RED;
            }
        }
    }

    addItem = (el) => {
        if (el) {
            let mainTextBox = this.state.mainTextBox;
            mainTextBox = removeSpace({ text: mainTextBox, term: ArticleTypes.TERM });
            const { clipId, currentTarget } = this.props.timeCurrentObj;
            if (mainTextBox) {
                let addedEntry = {};
                el.style.outline = ArticleTypes.BORDER_NONE;
                addedEntry.comment = mainTextBox;
                if (currentTarget && currentTarget.currentTime && clipId == this.props.clip.id) {
                    addedEntry.tcin = currentTarget.currentTime.toFixed(1);
                    addedEntry.tcout = currentTarget.currentTime.toFixed(1);
                }
                
                // NICK START
                if(this.props.onAdd) {
                    addedEntry = this.props.onAdd(addedEntry);
                }
                // NICK END
                
                this.props.addClipTimeComment(this.props.clip.id, addedEntry);
                
            } else {
                this.setState({ mainTextBox: '' });
                el.style.outline = ArticleTypes.BORDER_RED;
            }
        }
    }
    

    onFilterDDItemClick = (name, id, value) => {
        this.setInitBtn();
        this.props.updateArticleObjects({
            articleTimeComments: {
                currentFilter: value, currentFilterName: id,
                currentSortShowAll: false, currentFilterTrigger: false
            }
        });
        let data = [];
        if (value) data = LogsHelper.filterActions({ data: this.getComments(), currentFilter: value, property: 'time' });
        this.setState({ data });
    }

    onMainBtnClick = (item) => e => {
        this.setInitBtn();
        this.setState({ [`${item.name}_btnClasses`]: ArticleTypes.BTN_ACTIVE });
        let el = document.getElementById("mainTextBoxId");
        switch (item.name) {
            case ArticleTypes.ADD:
                return this.addItem(el);
            case ArticleTypes.SEARCH:
                return this.searchItems(el);
            case ArticleTypes.ALL:
                return this.setInitData();
            default:
                break;
        }
    }

    renderMainBtnBox = () => {
        return ArticleTypes.TC_BTN_ITEMS.map(item => {
            if (item.type && item.type === ArticleTypes.DROPDOWN) return (
                <CustomDropdown name={item.name} current={'Filter'}
                    trigger={this.props.articleObjects.articleTimeComments.currentFilterTrigger}
                    onDDItemClick={this.onFilterDDItemClick} data={item.data} styleClasses="custom-commentsdd" />)

            return (
                <button className={this.state[`${item.name}_btnClasses`]} onClick={this.onMainBtnClick(item)}>
                    <span>{this.props.intl.formatMessage({ id: item.intl })}</span>
                    <FontAwesomeIcon icon={item.icon} />
                </button>)
        })
    }

    onEditItemClick = (item, name) => () => {
        const { clipId, currentTarget } = this.props.timeCurrentObj;
        if (currentTarget.currentTime && clipId == this.props.clip.id) {
            let time = currentTarget.currentTime.toFixed(1);
            if (this.state[`commentEntry_${item.id}`]) {
                this.setState({ [`commentEntry_${item.id}`]: { ...this.state[`commentEntry_${item.id}`], [name]: time } });
            } else this.setState({ [`commentEntry_${item.id}`]: { ...item, [name]: time } });
        }
    }

    onItemClick = (item, name) => () => {
        let duration = this.state.clipDuration || ArticleTypes.INIT_DUR;
        let curTime = parseFloat(item[name]);
        let changedTime = (curTime && curTime > duration) ? duration : curTime;
        if (!changedTime) changedTime = ArticleTypes.INIT_DUR;
        this.props.changeClipTimeCurrent(this.props.clip.id, changedTime);
    }

    showItemMode = (item, el) => {
        if (this.state[`commentEdit${item.id}`]) {
            if (el.name === ArticleTypes.MINUS) return <div />
            else return <input className="custom-input" type="text" id={`${el.name}Input_${item.id}`}
                placeholder={TimeHelper.displayTimeCode(this.state[`commentEntry_${item.id}`][el.name], this.state.hasHours)}
                onChange={this.onChangeHandle(item, el.name)} onClick={this.onEditItemClick(item, el.name)}
                onKeyPress={PageHelper.onKeyPress(`${el.name}Input_${item.id}`, this.onSaveClick(item))}
            />
        }
        if (el.name === ArticleTypes.MINUS) return <FontAwesomeIcon icon={faMinus} />
        return (
            <div className="" onClick={this.onItemClick(item, el.name)}>
                {TimeHelper.displayTimeCode(item[el.name], this.state.hasHours)}
            </div>)
    }


    getBodyTimeClasses = (item) => {
        if (ArticleTypes.TC_EDIT_ITEMS.length == 1) {
            if (this.state[`commentEdit${item.id}`]) return "custom-smtimeedit";
            return "custom-smtime";
        }

        if (this.state.hasHours) return "custom-lgtime"
        return "custom-time"
    }

    showBodyTime = (item) => {
        return (
            <div className={this.getBodyTimeClasses(item)}>
                {ArticleTypes.TC_EDIT_ITEMS.map(el => this.showItemMode(item, el))}
            </div>)
    }

    showBodyBtnBox = (item) => {
        return (
            <div className="custom-btngroup">
                {
                    // NICK START
                    this.props.getAdditionalControls && this.props.getAdditionalControls(item) 
                    // NICK END
                }
                {this.state[`commentEdit${item.id}`] ?
                    <div className="custom-flex">
                        <div className="custom-rounded" onClick={this.onSaveClick(item)}><FontAwesomeIcon icon={faSave} /></div>
                        <div className="custom-rounded" onClick={this.onCancelClick(item)}><FontAwesomeIcon icon={faTimesCircle} /></div>
                    </div>
                    : <div className="custom-rounded" onClick={this.onEditClick(item)} ><FontAwesomeIcon icon={faEdit} /></div>}
                <div className="custom-rounded" onClick={this.onTrashClick(item)}><FontAwesomeIcon icon={faTrash} /></div>
            </div>)
    }

    onHandleChange = ({ item, name }) => e => {
        if (item) {
            if (this.state[`commentEntry_${item.id}`]) {
                this.setState({ [`commentEntry_${item.id}`]: { ...item, ...this.state[`commentEntry_${item.id}`], comment: e } });
            }
            else this.setState({ [`commentEntry_${item.id}`]: { ...item, comment: e } });
        }
        if (name) this.setState({ [name]: e });
    }

    onKeydown = ({ item, elId }) => (e) => {
        if (e.keyCode === ArticleTypes.ENTER_CODE && !e.shiftKey) {
            if (item) this.onSaveClick(item)();
            if (elId) {
                let el = document.getElementById(elId);
                this.addItem(el);
            }
        }
    }

    setActiveTab = () => {
        if(this.props.activeTab) {
            ArticleTypes.TC_TABS.forEach(item => {
                if (item.name === this.props.activeTab) {
                    this.setState({ tabStyle: { [item.name]: { ...ArticleTypes.ACTIVE_BTN } }, activeTab: item.name });
                }
            })
        } else {
            ArticleTypes.TC_TABS.forEach(item => {
                if (item.isActive) {
                    this.setState({ tabStyle: { [item.name]: { ...ArticleTypes.ACTIVE_BTN } }, activeTab: item.name });
                }
            })
        }
    }

    onTabClick = (item) => () => {
        this.setState({
            tabStyle: { [item.name]: { ...ArticleTypes.ACTIVE_BTN } },
            activeTab: item.name
        })
        this.props.setTab(item.name);
    }

    renderHeader = () => {
        if (isPMDB())
            return (
                <div className="custom-contentheader">
                    {ArticleTypes.TC_TABS.map(item => (
                        <div className="custom-tab" onClick={this.onTabClick(item)}
                            style={this.state.tabStyle[item.name]}>
                            {this.props.intl.formatMessage({ id: item.intl })}
                        </div>
                    ))
                    }
                </div>)
        return;
    }

    renderBody = (item) => {
        return (
            <div key={item.tcin} className="custom-flex custom-mb10">
                {
                    // NICK START
                    this.props.getThumb && this.props.getThumb(item)
                    // NICK END
                }
                {this.showBodyTime(item)}
                <div className={this.state[`commentEdit${item.id}`] ? `custom-commentedit` : `custom-comment`}
                    id={`${item.id}_TextBoxId`}>
                    {this.state[`commentEdit${item.id}`] ?
                        <ReactQuill theme="snow" onChange={this.onHandleChange({ item })} onKeyDown={this.onKeydown({ item })}
                            modules={sxmodules} formats={formats} name={`commentEntry_${item.id}`}
                            value={this.state[`commentEntry_${item.id}`].comment} />
                        : <div className="custom-text">{item.comment ? parse(item.comment) : ''}</div>}
                </div>
                {this.showBodyBtnBox(item)}
            </div >
        )
    }

    renderContent = () => {
        if (true/*(isPMDB() && this.state.activeTab === "tab_chapters") || !isPMDB()*/) {
            return (<div className="custom-contentbody">
                {this.state.data.map(item => this.renderBody(item))}
            </div>)
        }
        return <div className="custom-contentbody"></div>
    }

    renderFooter = () => {
        return (
            <div className="custom-contentfooter">
                <div className="custom-mainbox" id="mainTextBoxId">
                    <ReactQuill theme="snow" onChange={this.onHandleChange({ name: "mainTextBox" })}
                        onKeyDown={this.onKeydown({ elId: "mainTextBoxId" })}
                        placeholder={this.props.intl.formatMessage({ id: `data.timecomment.maintextbox` })}
                        modules={sxmodules} formats={formats} value={this.state[`mainTextBox`]} name="mainTextBox" />

                </div>
                <div className="custom-mainbtnbox">
                    {this.renderMainBtnBox()}
                </div>
            </div>)
    }
	
	renderExtraControl = () => {
		if(!this.props.extraControl) return "";
		
		return(
			<FlexRow>{this.props.extraControl}</FlexRow>
		);
	}
    
    renderInfo = () => {
        if(!this.props.infoText) {
            return "";
        }
        
        return (
            <div className="custom-contentinfo">
                <div className="custom-mainbox" id="mainTextBoxId">
                    <FormattedMessage id={this.props.infoText} />
                </div>
            </div>)
    }

    render() {
        return (
            <div className="TimeComments" onClick={PageHelper.onPageClick}>
                <div className="custom-container">
                    {this.renderHeader()}
                    {this.renderContent()}
					{this.renderExtraControl()}
                    {!this.props.limited && this.renderFooter()}
                    {this.renderInfo()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    
    // NICK START
    const timeComments = ownProps.timeComments || state.comment.clipTimeComments;
    // NICK END
	
	console.log(timeComments);
    
    return {
        timeComments: timeComments,
        timeCurrentObj: state.comment.clipTimeCurrent,
        articleObjects: state.article.articleObjects,
        activeTab: state.comment.tab
    }
}

const mapDispatchToProps = dispatch => ({
    getClipTimeComments: (clipId, type) => dispatch(actions.getClipTimeComments(clipId, type)),
    addClipTimeComment: (clipId, entry) => dispatch(actions.addClipTimeComment(clipId, entry)),
    updateClipTimeComment: (clipId, entry) => dispatch(actions.updateClipTimeComment(clipId, entry)),
    deleteClipTimeComment: (clipId, commentId, entry) => dispatch(actions.deleteClipTimeComment(clipId, commentId, entry)),
    updateArticleObjects: (data) => dispatch(actions.updateArticleObjects(data)),
    changeClipTimeCurrent: (clipId, changedTime) => dispatch(actions.changeClipTimeCurrent(clipId, changedTime)),
    setTab: (tab) => dispatch(actions.setTab(tab)),
    addThumb: (clipId, time, chapter) => dispatch(actions.addThumb(clipId, time, chapter)),
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TimeComments));
